export default defineNuxtRouteMiddleware(to => {
    if (import.meta.server) return;

    const countryCookie = useCookie('country');
    if (!countryCookie.value) return;

    const country = useState<AvailableCountries>('country', () => 'de');
    const { countryConfig } = useCountrySwitch();

    const prefix = countryConfig[countryCookie.value].prefix;

    // If country prefix should be present but was not found redirect to correct country
    if (prefix.length && to.fullPath.indexOf(prefix) === -1) {
        window.location.replace(`${prefix}/`);
        country.value = countryCookie.value;
        return false;
    }

    if (
        !prefix.length &&
        Object.keys(countryConfig).some(countryKey => {
            const prefix = countryConfig[countryKey].prefix;

            if (!prefix.length) return false;

            return false;
        })
    ) {
        window.location.replace(`/`);
        country.value = 'de';
        return false;
    }
});
